export default "__VITE_PUBLIC_ASSET__6f006f60__"